module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '落地页名称',
      value: 'name',
    },
    {
      name: '落地页URL',
      value: 'url',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-link',
          {
            props: {
              underline: false,
            },
            on: {
              click: () => {
                window.open(row.url);
              },
            },
          },
          row.url,
        );
        return ele;
      },
    },
    {
      name: '页面ID',
      width: 100,
      format: (row) => {
        const { baidu_params = {}} = row;
        const { page_id = '' } = baidu_params;
        return page_id || '-';
      },
    },
  ];
};
